import { ItemStatus, Order } from '@/redux/back-dashboard-api';

type OrderItemLastStatus = {
  items: { lastStatus: ItemStatus }[];
};

export const isOrderActive = (order: Order) =>
  order.items.some(({ lastStatus }) =>
    [ItemStatus.Pending].includes(lastStatus)
  );

export const isOrderInPreparation = (order: Order) =>
  order.items.some(({ lastStatus }) =>
    [ItemStatus.Approved, ItemStatus.Prepared].includes(lastStatus)
  );

export const isOrderInReturn = (order: Order) =>
  order.items.some(({ lastStatus }) =>
    [ItemStatus.Recalled, ItemStatus.Refurbish].includes(lastStatus)
  );

export const isOrderCompleted = (order: OrderItemLastStatus) =>
  order.items.every(({ lastStatus }) =>
    [
      ItemStatus.Rejected,
      ItemStatus.Cancelled,
      ItemStatus.Discarded,
      ItemStatus.Collected,
      ItemStatus.Returned,
    ].includes(lastStatus)
  );
